import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import { getSessionStorage } from '@bingads-webui/storage';
import ViewModel from '../viewmodel/index';
import template from '../template/index.pug';
import { RecommendationFilterBanner } from './filterBanner';

// TODO: Change to React
export class RecommendationStatusLightbox extends Backbone.View {
  /**
   * @param {Object} i18n - i18n object.
   * @param {Object} results - results from MT
   * @return {void} void
   */
  initialize({
    results,
    i18n,
    newI18n,
    view,
    filterByOpportunityId,
    removeFilter,
    recommendationType,
    formatNotificationLocalizedKey,
    currentActivity,
  }) {
    this.i18n = i18n;
    this.view = view;
    this.filterByOpportunityId = filterByOpportunityId;
    this.removeFilter = removeFilter;
    this.recommendationType = recommendationType;
    this.formatNotificationLocalizedKey = formatNotificationLocalizedKey;
    this.currentActivity = currentActivity;

    this.viewModel = new ViewModel({
      i18n,
      newI18n,
      aggregatedResult: results,
      recommendationType,
      formatNotificationLocalizedKey,
    });
  }

  getOpportunityIdsFromResults(errorCode) {
    return _.chain(this.viewModel.aggregatedResult().AggregatedResults)
      .find(result => result.ErrorCode === Number(errorCode))
      .result('OpportunityIds')
      .value();
  }

  get events() {
    return {
      'click .cancel': this.close,
      'click .filterBannerLink': this.showFilterBanner,
    };
  }

  show() {
    this.viewModel.showNotificationPanel(true);
    getSessionStorage().clear();
  }

  close() {
    this.viewModel.showNotificationPanel(false);
  }

  showFilterBanner(el) {
    this.filterByOpportunityId(
      this.view ? this.view.grid.gridView : null,
      this.getOpportunityIdsFromResults(el.target.id)
    );

    if ($('.filterBanner-container').hasClass('.filterBanner')) {
      $('.filterBanner').remove();
    }
    this.recommendationFilterBanner = new RecommendationFilterBanner({
      opportunityIds: this.getOpportunityIdsFromResults(el.target.id),
      i18n: this.i18n,
      view: this.view,
      removeFilter: this.removeFilter,
      reason: this.viewModel.getReasonByErrorCode(el.target.id),
      el: $('.filterBanner-container'),
    });

    this.recommendationFilterBanner.render();
  }

  render() {
    const model = {
      i18n: this.i18n,
    };
    this.$el.html(template(model));
    ko.applyBindings(this.viewModel, this.el);

    this.on('show', this.show);
    return this;
  }
}
